import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { $emitter } from '@/services/emitter';

type CategoryItemActionProps = {
  prefix: string;
  selectedBrands: string[];
  brandSelectAllIndex: Record<string, boolean>;
  item: { name: string };
  noEvents?: boolean;
};

export const useFlowThreePanelCategoryItemAction = (props: CategoryItemActionProps) => {
  const pSelectedBrands = ref<string[]>(props.selectedBrands);
  const pBrandSelectAllIndex = ref<Record<string, boolean>>(props.brandSelectAllIndex);

  const onBusSelectedBrands = (selectedBrands: string[]) => {
    pSelectedBrands.value = selectedBrands;
  };

  const onBusBrandSelectAllIndex = (brandSelectAllIndex: Record<string, boolean>) => {
    pBrandSelectAllIndex.value = brandSelectAllIndex;
  };

  onMounted(() => {
    if (!props.noEvents) {
      $emitter.on(`${props.prefix}-selected-brands`, onBusSelectedBrands);
      $emitter.on(`${props.prefix}-brand-select-all-index`, onBusBrandSelectAllIndex);
    }
  });

  onUnmounted(() => {
    if (!props.noEvents) {
      $emitter.off(`${props.prefix}-selected-brands`, onBusSelectedBrands);
      $emitter.off(`${props.prefix}-brand-select-all-index`, onBusBrandSelectAllIndex);
    }
  });

  const isPickedAll = computed(() => pBrandSelectAllIndex.value[props.item.name]);

  const isBrandSelected = computed(() => props.selectedBrands.includes(props.item.name));

  return {
    isPickedAll,
    isBrandSelected,
  };
};
